export default __webpack_public_path__ + "static/media/htb-dominika.371a8356.jpg";